import { render, staticRenderFns } from "./DataVisualization.vue?vue&type=template&id=59b52197&scoped=true"
import script from "./DataVisualization.vue?vue&type=script&lang=js"
export * from "./DataVisualization.vue?vue&type=script&lang=js"
import style0 from "./DataVisualization.vue?vue&type=style&index=0&id=59b52197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b52197",
  null
  
)

export default component.exports